import { Button2, Text } from 'platform-components';
// @ts-ignore
import { BUTTON_THEMES } from 'platform-components/src/components/button2/button2';
import React from 'react';
import { connect } from 'react-redux';
import ym from 'react-yandex-metrika';
import { Action, bindActionCreators, Dispatch } from 'redux';

import * as lessonViewActions from 'common.components/lesson-view.store/actions/';
import * as lessonSelectors from 'common.components/lesson/selectors';

interface StoreProps {
    cLessonId: number | null;
}

interface DispatchProps {
    deleteCLesson: typeof lessonViewActions.deleteCLessonAsync;
}

interface Props extends StoreProps, DispatchProps {}

export const Button = (props: Props) => {
    const { deleteCLesson, cLessonId } = props;

    const handleDeleteLesson = async () => {
        if (cLessonId) {
            await deleteCLesson({ cLessonId });
            ym('reachGoal', 'button_delete_lesson');
        }
    };

    return (
        <Button2 mix="side-panel__action-button" onClick={handleDeleteLesson} theme={BUTTON_THEMES.BLUE}>
            <Text id="lessonModal.header.deleteLesson" weight={Text.WEIGHT.M} />
        </Button2>
    );
};

const mapStateToProps = (storeState: any): StoreProps => ({
    cLessonId: lessonSelectors.getCLessonId(storeState),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return bindActionCreators(
        {
            deleteCLesson: lessonViewActions.deleteCLessonAsync,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Button);
